import React from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, Star, Zap } from 'lucide-react';
import { AnimatedSection, staggerContainer, staggerItem } from './AnimatedSection';
export function SocialProofBar() {
  return <AnimatedSection className="bg-white border-b border-slate-100 py-5 sm:py-10" data-id="element-15773">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15774">
        <motion.div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 text-center" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-15775">
          {[{
          num: '50,000+',
          label: 'Пользователей',
          icon: <Users className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-15776" />
        }, {
          num: '2,000+',
          label: 'Консультаций',
          icon: <BookOpen className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-15777" />
        }, {
          num: '150+',
          label: 'Астрологов',
          icon: <Star className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-15778" />
        }, {
          num: '4.9★',
          label: 'Средний рейтинг',
          icon: <Zap className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-15779" />
        }].map((stat, i) => <motion.div key={i} variants={staggerItem} className="flex flex-col items-center" data-id="element-15780">
              <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 mb-1.5 sm:mb-3" data-id="element-15781">
                {stat.icon}
              </div>
              <div className="text-lg sm:text-2xl md:text-3xl font-bold text-slate-900 mb-0.5 sm:mb-1" data-id="element-15782">
                {stat.num}
              </div>
              <div className="text-[10px] sm:text-sm text-slate-500" data-id="element-15783">
                {stat.label}
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </AnimatedSection>;
}